<mat-form-field
  class="form-control"
  hideRequiredMarker="true"
  [ngClass]="{ 'is-invalid-field': isInvalid }"
  [tooltip]="tooltip"
>
  <mat-select [formControl]="control" [multiple]="multiple" [placeholder]="placeholder">
    @if (searchable) {
<div class="search-option px-3">
      <mat-icon class="search-icon" matPrefix aria-label="Search Icon">search</mat-icon>
      <input
        type="text"
        class="search-input"
        matInput
        [placeholder]="placeholder"
        [formControl]="searchControl"
        (keydown.space)="$event.stopPropagation()"
      />
      <button mat-icon-button>
        @if (searchControl?.value) {
<mat-icon
         
          matSuffix
          class="clear-icon"
          aria-label="Clear"
          (click)="clearSearch($event)"
          >clear</mat-icon
        >
}
      </button>
    </div>
}
    @if (hasAllOption && !searchControl?.value) {
<mat-option [value]="'all'">All</mat-option>
}
    @if (data.length > 0 && isString(data[0])) {

      @for (item of data; track item) {
<mat-option [value]="item" [disabled]="control.value?.includes('all')">{{
        item
      }}</mat-option>
}
    
} @else {

      @for (item of data; track item) {
<mat-option [value]="item[valueProperty]" [disabled]="control.value?.includes('all')">{{
        item[displayProperty]
      }}</mat-option>
}
    
}
    
  </mat-select>
</mat-form-field>
@if (isInvalid) {
<div class="error-message">
  <div>{{ errorMessage }}</div>
</div>
}
